import React, { useEffect, useState } from "react";
import { useNavigate, NavLink, Link } from "react-router-dom";
import {
  delivery1,
  delivery2,
  delivery3,
  deliveryImg,
  headingIcon,
  order1,
  order2,
  placeImg,
  playIcon,
  shape1,
  shape2,
  shape3,
  ttw43,
  work1,
  work2,
  work3,
  work4,
  workImg,
} from "../../assets/img";
import { useDispatch, useSelector } from "react-redux/es/exports";
import { data } from "../edit/data";
import {
  fetchCroppedImage,
  fetchHomeJsonList,
  fetchPostalCodes,
  fetchThemeEdit,
  fetchWBDJsonList,
  getHomeJsonList,
  getSettingsWBDvedio,
  getWBDJsonList,
  saveThemeJsonData,
} from "../../redux/Actions";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import axios from "../../config";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { UKPostalCode } from "../core/regex";
import * as yup from "yup";
import { checkShopListFlow, setValue } from "../../utility";
import {
  fetchAddressByPincode,
  fetchGetShopByPinCode,
  fetchSaveAddress,
} from "../../redux/Actions/checkoutPageActions";
import Select from "react-select";
import {
  clearCart,
  clearCartCount,
  setOrderType,
} from "../../redux/Actions/cartCountAction";
import { clearUserProductCategories } from "../../redux/Actions/productCategoriesAction";
import wing1 from "../../assets/img/home/wing1.png";
import wing2 from "../../assets/img/home/wing2.png";
import wing3 from "../../assets/img/home/wing3.png";
import wing4 from "../../assets/img/home/wing4.png";
import { ColorPicker } from "primereact/colorpicker";
import { Chips } from "primereact/chips";
import _cloneDeep from "lodash/cloneDeep";
const images = [
  "assets/shoe-repair/close-up-engraving-art-tools.jpg",
  "assets/shoe-repair/cobbler-works-his-workshop.jpg",
  "assets/shoe-repair/mature-shoemaker-workshop-making-shoes.jpg",
  "assets/shoe-repair/shoemaker-workshop-making-shoes.jpg",
];

const searchPinCodeFormSchema = yup.object().shape({
  pinCode: yup
    .string()
    .required("Pin code is required")
    .matches(UKPostalCode, "Enter a valid Pin code")
    .trim()
    .max(8, "Enter a valid Pin code"),
});

const addressFormSchema = yup.object().shape({
  address: yup
    .object()
    .shape({
      label: yup.string().required("Address is required to proceed"),
      value: yup.string().required("Address is required to proceed"),
    })
    .test("address.value", "Address is required to proceed", (value: any) => {
      if (value.value == "") {
        return false;
      } else return true;
    })
    .required("Address is required to proceed"),
});

function WBDEdit() {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  useEffect(() => {
    dispatch(fetchHomeJsonList(data));
  }, [data, dispatch]);
  const Url = window.location.host;
  const blogUrl = `https://blog.${Url}`;
  const base_url = process.env.REACT_APP_BACKEND_URL;
  const homedata: any = useSelector<any>((state) => state?.homeJsonList);
  const [areaCovered, setAreaCovered] = useState<any | null>({});
  const [settings, setSettings] = useState<any>({});
  const appStorel =
    Object.keys(settings).length > 0 &&
    settings.WebmasterSettings.app_store_link;
  const playStore =
    Object.keys(settings).length > 0 &&
    settings.WebmasterSettings.play_store_link;
  const [coveredArea, setCoveredArea] = useState(false);
  const [postalCodeList, setPostalCodeList] = useState([]);
  const [postalCodeValue, setPostalCodeValue] = useState("");
  const state: any = useSelector((state) => state);
  const [checkWithNewPin, setCheckWithNewPin] = useState(true);
  const href = window.location.href;
  const [areaData, setAreaData] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState<any>(null);
  const [editedData, setJsonData] = useState<any>();
  const jsonData: any = useSelector<any>((state) => state.homeJsonList);
  const [imagedata, setImagedata] = useState<any>("" || undefined);
  const [showCropModal, setShowCropModal] = useState<boolean>(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [wbdVedio, setWBDVedio] = useState("");
  const handlePlayClick = () => {
    setIsPlaying(true);
  };
  const handleCloseClick = () => {
    setIsPlaying(false);
  };

  const areaOptions: any = useSelector<any>(
    (state) => state?.addressByPincode?.data?.address_list
  );
  const [listOfSuggestedAddress, setListOfSuggestedAddress] = useState([]);
  const settingsslider = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
  };

  // Import specific css for this page
  useEffect(() => {
    if (
      window.location.href.includes("laundryup") ||
      (window.location.href.includes("localhost") &&
        window.location.href.toLowerCase().includes("wbsl"))
    ) {
      import("../../assets/css/laundryup.css");
    }
    submitPostalForm("");
  }, []);

  useEffect(() => {}, [homedata]);
  useEffect(() => {
    let currentShopId = localStorage.getItem("currentShopHome") || null;
    const url = new URL(window.location.href);
    const url_array = url.pathname.split("/").filter(Boolean);
    let shop_name = url_array[1];
    const headers = {
      Accept: "application/json",
    };

    axios
      .get(
        `${base_url}/api/areas_covered?shop_name=${shop_name}&shop_id=${currentShopId}`,
        {
          headers: headers,
        }
      )
      .then((e: any) => {
        setAreaCovered({ data: e.data });
      });
  }, []);
  const popAreadCovered = (areaList: any) => {
    var test = Object.keys(areaList)
      .slice(0, 6)
      .map((location, locationindex) => {
        let cityArr = areaList[location].toString().split(",").slice(0, 1);
        console.log("city", cityArr);
        return (
          <>
            <div key={locationindex}>
              {cityArr.map((city: any, cityIndex: any) => (
                <li key={cityIndex}>
                  <a
                  // href="#"
                  // onClick={(e) => {
                  //   e.preventDefault();
                  //   navigate("/dry-cleaners/" + city);
                  // }}
                  >
                    {city}
                  </a>
                </li>
              ))}
            </div>
          </>
        );
      });

    return test;
  };
  const popAreadCovered2 = (areaList: any) => {
    if (Object.keys(areaList).length > 6) {
      return (
        <button
          key="showMore"
          className="ftransbtn"
          onClick={navigateToAreaCovered}
        >
          Show More
        </button>
      );
    }
  };
  const navigateToAreaCovered = () => {
    const shopName: any = localStorage.getItem("currentShopName");
    if (shopName) {
      const finalResult = shopName
        .trim()
        .replace(/\s(.)/g, (match: any) => match.toUpperCase())
        .replace(/\s/g, "")
        .replace(/^(.)/, (match: any) => match.toLowerCase());
      if (shopName) {
        navigate(`/shop/${finalResult}/areaCovered`);
      } else {
        navigate("/areaCovered");
      }
    } else {
      navigate("/areaCovered");
    }
  };

  const {
    handleSubmit: handlePinCodeSubmit,
    control: pinCodeFormControl,
    setError: setPinCodeFormError,
    setValue: setPinCodeFormValue,
    formState: { errors: pinCodeFormError },
  } = useForm({
    resolver: yupResolver(searchPinCodeFormSchema),
    mode: "onChange",
    defaultValues: {
      pinCode: "",
    },
  });

  const handleChange = (e: any) => {
    setCoveredArea(false);
    const { value } = e.target;
    const updateValue = value.replace(/\s/g, "");
    setPinCodeFormValue("pinCode", updateValue);
    if (value.length > 0) {
      dispatch(fetchPostalCodes(updateValue));
    }
    setPostalCodeValue(updateValue);
  };

  useEffect(() => {
    if (state) {
      setPostalCodeList(state.postalCodeList);
    }
  }, [state]);

  const onSearch = (searchTerm: any) => {
    setPinCodeFormValue("pinCode", searchTerm);
    setPostalCodeValue(searchTerm);
    setValue("postalCode", searchTerm.toUpperCase());
  };

  const fetchCoveredAreaCodes = async () => {
    const base_url = process.env.REACT_APP_BACKEND_URL;
    try {
      const response = await axios({
        method: "get",
        url: `${base_url}/api/areas_covered_postcodes`,
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Methods": "GET, POST",
          "Access-Control-Allow-Origin": "*",
        },
      });
      if (response.data.Response.response_code == "1") {
        setAreaData(response.data.data);
      } else {
        return false;
      }
    } catch (error) {}
  };

  const submitPostalForm = async (data: any) => {
    localStorage.setItem("postalCode", JSON.stringify("WBD"));
    const shop = await dispatch(fetchGetShopByPinCode(JSON.stringify("WBD")));
    // if (shop) {
    setCoveredArea(false);
    const result = await dispatch(fetchAddressByPincode());
    if (result.status == 200 && result.data.data?.address_list.length > 0) {
      setCheckWithNewPin(false);
      setCoveredArea(false);
    } else {
      if (href.includes("wblaundry") || href.includes("localhost")) {
        navigate("/areaNotCovered");
      } else {
        setPinCodeFormError("pinCode", {
          type: "server",
          message: "Area not covered",
        });
        await fetchCoveredAreaCodes();
        setCoveredArea(true);
      }
    }
    // } else {

    // }
  };

  const {
    handleSubmit: handleAddressSubmit,
    control: addressFormControl,
    setError: addressFormSetError,
    setValue: setAddressFormValue,
    getValues: getValuesAddressForm,
    reset: resetAddressForm,
    clearErrors,
    formState: { errors: addressFormError },
  } = useForm({
    resolver: yupResolver(addressFormSchema),
    mode: "onChange",
    defaultValues: {
      address: { value: "", label: "Select your address..." },
    },
  });
  const handleAddressChange = async (selected: any) => {
    setSelectedAddress(selected);
    setAddressFormValue("address", selected);
    if (getValuesAddressForm("address")?.value != "") {
      clearErrors();
    }
  };

  const submitAddressChange = async () => {
    let postalCode: any = localStorage.getItem("postalCode");
    if (getValuesAddressForm("address")?.value == "") {
      addressFormSetError("address", {
        type: "server",
        message: "Address is required to proceed",
      });
    } else {
      clearErrors();
      localStorage.setItem(
        "selectedAddressBeforeLogin",
        JSON.stringify(selectedAddress)
      );
      if (localStorage.getItem("token")) {
        // handle api
        const contact_name = JSON.parse(localStorage.getItem("userDetails")!)
          .data?.user_info.name;
        const mobile_number = JSON.parse(localStorage.getItem("userDetails")!)
          .data?.user_info.mobile;
        const address = selectedAddress?.value?.split(",");
        const payloadData = {
          address_type: "pickup",
          address_details: `{"contact_name":"${contact_name}","mobile_number":"${mobile_number}","line_1":"${address[0].trim()}","line_2":"${address[1].trim()}","line_3":"${address[2].trim()}","line_4":"${address[3].trim()}","locality":"${address[4].trim()}","city":"${address[5].trim()}","county":"${address[6].trim()}","label":"Home","pincode":"${address[7].trim()}"}`,
        };
        localStorage.setItem("postalCode", JSON.stringify(address[7].trim()));
        const uniqueAddress = await dispatch(fetchSaveAddress(payloadData));
        if (
          uniqueAddress.status ||
          uniqueAddress.message == "Address already exists"
        ) {
          let host = window.location.hostname;
          // If host contains fulham move to checkout directly

          const results = await dispatch(fetchGetShopByPinCode(postalCode));

          if (!results) {
            setPinCodeFormError("pinCode", {
              type: "server",
              message: "Area not covered",
            });
            await fetchCoveredAreaCodes();
            setCoveredArea(true);
            return;
          }
          dispatch(setOrderType(1));
          setValue("orderType", 1);
          localStorage.removeItem("cartInformationData");
          dispatch(clearCartCount());
          dispatch(clearCart());
          dispatch(clearUserProductCategories());
          localStorage.removeItem("isloaded");
          // dispatch(clearSplitPrice());
          let userName = JSON.parse(localStorage.getItem("userDetails")!);
          userName == null ? navigate("/guestLogin") : navigate("/checkOut");
          if (userName == null) {
            navigate("/login");
          } else {
            navigate("/checkOut");
          }
        } else {
          addressFormSetError("address", {
            type: "server",
            message: "Unable to set address try again later",
          });
        }
      } else {
        let host = window.location.hostname;
        // If host contains fulham move to checkout directly
        const results = await dispatch(fetchGetShopByPinCode(postalCode));

        if (!results) {
          setPinCodeFormError("pinCode", {
            type: "server",
            message: "Area not covered",
          });
          await fetchCoveredAreaCodes();
          setCoveredArea(true);
          return;
        }
        dispatch(setOrderType(1));
        setValue("orderType", 1);
        localStorage.removeItem("cartInformationData");
        dispatch(clearCartCount());
        dispatch(clearCart());
        dispatch(clearUserProductCategories());
        localStorage.removeItem("isloaded");
        // dispatch(clearSplitPrice());
        let userName = JSON.parse(localStorage.getItem("userDetails")!);
        userName == null ? navigate("/guestLogin") : navigate("/checkOut");
        if (userName == null) {
          navigate("/login");
        } else {
          navigate("/checkOut");
        }
      }
    }
  };

  const tabs = ["heroimg.png", "heroimg.png"];

  const [activeIndex, setActiveIndex] = useState(0);

  const images = [wing1, wing2, wing3, wing4, wing2, wing3, wing4];

  const [activeTabThree, setActiveTabThree] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [activeTabTwo, setActiveTabTwo] = useState(0);
  const [editData, setEditData] = useState<any>();
  const [previewImage, setPreviewImage] = useState(null);
  const handlePreviewImageChange = (e: any) => {
    const file = e.target.files[0];

    if (file) {
      const imageUrl: any = URL.createObjectURL(file);
      setPreviewImage(imageUrl);
    }
  };
  const handleHeaderChange = (
    e: any,
    index?: any,
    checklistIndex?: any,
    isService?: boolean
  ) => {
    const { value, name } = e.target;

    setEditData((prevJsonData: any) => {
      const updatedCards = [...prevJsonData.theme_2.home.section_3.cards];

      if (index !== undefined) {
        if (isService) {
          updatedCards[index].services[checklistIndex][name] = value;
        } else if (checklistIndex !== undefined) {
          updatedCards[index].card_options[checklistIndex][name] = value;
        } else {
          updatedCards[index][name] = value;
        }
      }

      return {
        ...prevJsonData,
        theme_2: {
          ...prevJsonData.theme_2,
          home: {
            ...prevJsonData.theme_2.home,
            section_3: {
              ...prevJsonData.theme_2.home.section_3,
              [name]: value,
              cards: updatedCards,
            },
          },
        },
      };
    });
  };
  const addCollection = () => {
    setActiveTabTwo(activeTabTwo + 1);
    setEditData((prevJsonData: any) => {
      const updatedCards = [...prevJsonData.theme_2.home.section_3.cards];
      const activeCard = updatedCards[activeTab];
      const newServiceItem = {
        id: (activeCard.card_options.length + 1).toString(),
        list: "",
      };

      const newIndex = activeTabTwo + 1;

      const updatedCardOptions = [
        ...activeCard.card_options.slice(0, newIndex),
        newServiceItem,
        ...activeCard.card_options.slice(newIndex),
      ];

      const updatedActiveCard = {
        ...activeCard,
        card_options: updatedCardOptions,
      };

      updatedCards[activeTab] = updatedActiveCard;

      return {
        ...prevJsonData,
        theme_2: {
          ...prevJsonData.theme_2,
          home: {
            ...prevJsonData.theme_2.home,
            section_3: {
              ...prevJsonData.theme_2.home.section_3,
              cards: updatedCards,
            },
          },
        },
      };
    });
  };

  const handleCroppedImage = async (image: any) => {
    setShowCropModal(false);
    setImagedata(image);
    const imageLink = await dispatch(fetchCroppedImage(image));
    if (imageLink != false) {
      handleImageChange(imageLink);
    }
  };

  const updateImageSectionOne = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("300");
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };

  const handleImageChange5 = (image: string) => {
    //Update the banner value in the JSON data
    setJsonData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_6: {
        ...prevJsonData.theme_6,
        home: {
          ...prevJsonData.theme_6.home,
          section_5: {
            ...prevJsonData.theme_6.home.section_1,
            banner: image,
          },
        },
      },
    }));
  };
  const handleImageChange4 = (image: string) => {
    //Update the banner value in the JSON data
    setJsonData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_6: {
        ...prevJsonData?.theme_6,
        home: {
          ...prevJsonData?.theme_6?.home,
          section_4: {
            ...prevJsonData?.theme_6?.home?.section_4,
            banner: image,
          },
        },
      },
    }));
  };
  const handleImageChange2 = (image: string) => {
    //Update the banner value in the JSON data
    setJsonData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_6: {
        ...prevJsonData?.theme_6,
        home: {
          ...prevJsonData?.theme_6?.home,
          section_2: {
            ...prevJsonData?.theme_6?.home?.section_2,
            banner: image,
          },
        },
      },
    }));
  };

  const handleCroppedImage5 = async (image: any) => {
    setShowCropModal(false);
    setImagedata(image);
    const imageLink = await dispatch(fetchCroppedImage(image));
    if (imageLink != false) {
      handleImageChange5(imageLink);
    }
  };
  const handleCroppedImage4 = async (image: any) => {
    setShowCropModal(false);
    setImagedata(image);
    const imageLink = await dispatch(fetchCroppedImage(image));
    if (imageLink != false) {
      handleImageChange4(imageLink);
    }
  };
  const handleCroppedImage2 = async (image: any) => {
    setShowCropModal(false);
    setImagedata(image);
    const imageLink = await dispatch(fetchCroppedImage(image));
    if (imageLink != false) {
      handleImageChange2(imageLink);
    }
  };

  const updateImageSection5 = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("300");
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage5(res.target.result);
      };
    }
  };
  const updateImageSection4 = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("300");
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage4(res.target.result);
      };
    }
  };
  const updateImageSection2 = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("300");
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage2(res.target.result);
      };
    }
  };

  // const handleChipChange = (data: string) => {
  //   //Update the banner value in the JSON data
  //   setJsonData((prevJsonData: any) => ({
  //     ...prevJsonData,
  //     theme_6: {
  //       ...prevJsonData.theme_6,
  //       home: {
  //         ...prevJsonData.theme_6.home,
  //         section_3: {
  //           ...prevJsonData.theme_6.home.section_3,
  //           banner: image,
  //         },
  //       },
  //     },
  //   }));
  // };

  const handleChipsChange = (e: any) => {
    const [indexStr, field] = e.target.name.split("_");
    const index = parseInt(indexStr, 10);

    setJsonData((prevCards: any) => {
      const updatedCards = [...prevCards];
      updatedCards[index] = {
        ...updatedCards[index],
        [field]: e.value,
      };
      return updatedCards;
    });
  };

  const addServiceCollection = () => {
    setActiveTabThree(activeTabThree + 1);
    setEditData((prevJsonData: any) => {
      const updatedCards = [...prevJsonData.theme_2.home.section_3.cards];
      const activeCard = updatedCards[activeTab];
      const newServiceItem = {
        id: (activeCard.services.length + 1).toString(),
        list: "",
      };

      const newIndex = activeTabThree + 1;

      const updatedServices = [
        ...activeCard.services.slice(0, newIndex),
        newServiceItem,
        ...activeCard.services.slice(newIndex),
      ];

      const updatedActiveCard = {
        ...activeCard,
        services: updatedServices,
      };

      updatedCards[activeTab] = updatedActiveCard;

      return {
        ...prevJsonData,
        theme_2: {
          ...prevJsonData.theme_2,
          home: {
            ...prevJsonData.theme_2.home,
            section_3: {
              ...prevJsonData.theme_2.home.section_3,
              cards: updatedCards,
            },
          },
        },
      };
    });
  };
  const removeServiceCollection = (cardIndex: number, serviceIndex: number) => {
    setActiveTabThree(activeTabThree - 1);
    setEditData((prevJsonData: any) => {
      const updatedCards = [...prevJsonData.theme_2.home.section_3.cards];
      const activeCard = updatedCards[cardIndex];

      const updatedServices = activeCard.services.filter(
        (_: any, index: any) => index !== serviceIndex
      );

      const updatedActiveCard = {
        ...activeCard,
        services: updatedServices,
      };

      updatedCards[cardIndex] = updatedActiveCard;

      return {
        ...prevJsonData,
        theme_2: {
          ...prevJsonData.theme_2,
          home: {
            ...prevJsonData.theme_2.home,
            section_3: {
              ...prevJsonData.theme_2.home.section_3,
              cards: updatedCards,
            },
          },
        },
      };
    });
  };
  const removeCollection = (cardIndex: number, checklistIndex: number) => {
    setActiveTabTwo(activeTabTwo - 1);
    setEditData((prevJsonData: any) => {
      const updatedCards = [...prevJsonData.theme_2.home.section_3.cards];
      const activeCard = updatedCards[cardIndex];

      const updatedCard = activeCard.card_options.filter(
        (_: any, index: any) => index !== checklistIndex
      );

      const updatedActiveCard = {
        ...activeCard,
        card_options: updatedCard,
      };

      updatedCards[cardIndex] = updatedActiveCard;

      return {
        ...prevJsonData,
        theme_2: {
          ...prevJsonData.theme_2,
          home: {
            ...prevJsonData.theme_2.home,
            section_3: {
              ...prevJsonData.theme_2.home.section_3,
              cards: updatedCards,
            },
          },
        },
      };
    });
  };

  const initialBanners = [
    {
      title: "Card 1",
      bg: wing1,
      thumbnails: [wing4, wing2, wing3, wing4, wing2, wing3],
    },
    {
      title: "Card 2",
      bg: wing2,
      thumbnails: [wing1, wing3, wing4, wing4, wing2, wing3],
    },
  ];
  const section3icons = [
    {
      title: "Card 1",
      bg: order1,
      thumbnails: [order1, order2],
    },
    {
      title: "Card 2",
      bg: order2,
      thumbnails: [order1, order2],
    },
  ];
  const initialBanners3 = [
    {
      title: "Card 1",
      bg: wing4,
      thumbnails: [wing4, wing2, wing3, wing4, wing2, wing3],
    },
    {
      title: "Card 2",
      bg: wing1,
      thumbnails: [wing1, wing3, wing4, wing4, wing2, wing3],
    },
    {
      title: "Card 3",
      bg: wing4,
      thumbnails: [wing4, wing2, wing3, wing4, wing2, wing3],
    },
  ];
  const DeliveryScheduleIcons = [
    {
      title: "Card 1",
      bg: delivery1,
      thumbnails: [delivery1, delivery2, delivery3],
    },
    {
      title: "Card 2",
      bg: delivery2,
      thumbnails: [delivery2, delivery1, delivery3],
    },
    {
      title: "Card 3",
      bg: delivery3,
      thumbnails: [delivery3, delivery2, delivery1],
    },
  ];
  const initialBanners4 = [
    {
      title: "Card 1",
      bg: work1,
      thumbnails: [work1, work2, work3, work4],
    },
    {
      title: "Card 2",
      bg: work2,
      thumbnails: [work2, work1, work3, work4],
    },
    {
      title: "Card 3",
      bg: work3,
      thumbnails: [work3, work2, work1, work4],
    },
    {
      title: "Card 4",
      bg: work4,
      thumbnails: [work4, work2, work3, work1],
    },
  ];

  const [bannerData, setBannerData] = useState(initialBanners);
  const [section3Icons, setSection3Icons] = useState(section3icons);
  const [bannerData3, setBannerData3] = useState(initialBanners3);
  const [deliveryScheduleIcons, setDeliveryScheduleIcons] = useState(
    DeliveryScheduleIcons
  );
  const [bannerData4, setBannerData4] = useState(initialBanners4);

  const handleImageClick = (bannerIndex: number, image: string) => {
    const updated = [...bannerData];
    updated[bannerIndex].bg = image;
    setBannerData(updated);
  };
  const handleImageClickSection3Icons = (
    bannerIndex: number,
    image: string
  ) => {
    const updated = [...section3Icons];
    updated[bannerIndex].bg = image;
    setSection3Icons(updated);
  };
  const handleImageClick3 = (bannerIndex: number, image: string) => {
    const updated = [...bannerData3];
    updated[bannerIndex].bg = image;
    setBannerData3(updated);
  };
  const handleImageClickDeliverySIcons = (
    bannerIndex: number,
    image: string
  ) => {
    const updated = [...deliveryScheduleIcons];
    updated[bannerIndex].bg = image;
    setDeliveryScheduleIcons(updated);
  };
  const handleImageClick4 = (bannerIndex: number, image: string) => {
    const updated = [...bannerData4];
    updated[bannerIndex].bg = image;
    setBannerData4(updated);
  };

  useEffect(() => {
    setEditData({
      theme_2: {
        home: {
          section_3: {
            cards: [
              {
                bg_img: wing1,
                card_title: "Card 1",
                card_paragraph: "Paragraph 1",
                card_main_title: "Main Title 1",
                card_main_paragraph: "Main Paragraph 1",
                services: [{ list: "Service 1" }],
                card_options: [{ list: "Option 1" }],
              },
              {
                bg_img: wing2,
                card_title: "Card 1",
                card_paragraph: "Paragraph 1",
                card_main_title: "Main Title 1",
                card_main_paragraph: "Main Paragraph 1",
                services: [{ list: "Service 1" }],
                card_options: [{ list: "Option 1" }],
              },
            ],
          },
        },
      },
    });
  }, []);

  const handleChangeInput = (e: any) => {
    const { value, name, type, checked } = e.target;

    setJsonData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_6: {
        ...prevJsonData?.theme_6,
        home: {
          ...prevJsonData?.theme_6.home,
          section_1: {
            ...prevJsonData?.theme_6?.home.section_1,
            [name]: value,
            // btn_group: {
            //   ...prevJsonData?.theme_6?.home.section_1.btn_group,
            //   btn1: {
            //     ...prevJsonData?.theme_6?.home.section_1.btn_group.btn1,
            //     [name]: value,
            //   },
            // },
            // mobile_link_section: {
            //   ...prevJsonData?.theme_6?.home.section_1.mobile_link_section,
            //   [name]: value,
            //   is_enable:
            //     type === "checkbox" && name === "is_enable"
            //       ? !prevJsonData?.theme_6?.home.section_1.mobile_link_section
            //           .is_enable
            //       : prevJsonData?.theme_6?.home.section_1.mobile_link_section
            //           .is_enable,
            // },
          },
        },
      },
    }));
  };
  const handleChangeInputS6 = (e: any) => {
    const { value, name, type, checked } = e.target;

    setJsonData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_6: {
        ...prevJsonData?.theme_6,
        home: {
          ...prevJsonData?.theme_6.home,
          section_6: {
            ...prevJsonData?.theme_6?.home.section_6,
            [name]: value,
            // btn_group: {
            //   ...prevJsonData?.theme_6?.home.section_6.btn_group,
            //   btn1: {
            //     ...prevJsonData?.theme_6?.home.section_6.btn_group.btn1,
            //     [name]: value,
            //   },
            // },
            // mobile_link_section: {
            //   ...prevJsonData?.theme_6?.home.section_6.mobile_link_section,
            //   [name]: value,
            //   is_enable:
            //     type === "checkbox" && name === "is_enable"
            //       ? !prevJsonData?.theme_6?.home.section_6.mobile_link_section
            //           .is_enable
            //       : prevJsonData?.theme_6?.home.section_6.mobile_link_section
            //           .is_enable,
            // },
          },
        },
      },
    }));
  };
  const handleChangeInputS5 = (e: any) => {
    const { value, name, type, checked } = e.target;

    setJsonData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_6: {
        ...prevJsonData?.theme_6,
        home: {
          ...prevJsonData?.theme_6.home,
          section_5: {
            ...prevJsonData?.theme_6?.home.section_5,
            [name]: value,
            // btn_group: {
            //   ...prevJsonData?.theme_6?.home.section_6.btn_group,
            //   btn1: {
            //     ...prevJsonData?.theme_6?.home.section_6.btn_group.btn1,
            //     [name]: value,
            //   },
            // },
            // mobile_link_section: {
            //   ...prevJsonData?.theme_6?.home.section_6.mobile_link_section,
            //   [name]: value,
            //   is_enable:
            //     type === "checkbox" && name === "is_enable"
            //       ? !prevJsonData?.theme_6?.home.section_6.mobile_link_section
            //           .is_enable
            //       : prevJsonData?.theme_6?.home.section_6.mobile_link_section
            //           .is_enable,
            // },
          },
        },
      },
    }));
  };

  // const handleChangeInputS3 = (e: any) => {
  //   const { value, name, type, checked } = e.target;

  //   setJsonData((prevJsonData: any) => ({
  //     ...prevJsonData,
  //     theme_6: {
  //       ...prevJsonData?.theme_6,
  //       home: {
  //         ...prevJsonData?.theme_6.home,
  //         section_3: {
  //           ...prevJsonData?.theme_6?.home.section_3,
  //           [name]: value,
  //           // btn_group: {
  //           //   ...prevJsonData?.theme_6?.home.section_6.btn_group,
  //           //   btn1: {
  //           //     ...prevJsonData?.theme_6?.home.section_6.btn_group.btn1,
  //           //     [name]: value,
  //           //   },
  //           // },
  //           // mobile_link_section: {
  //           //   ...prevJsonData?.theme_6?.home.section_6.mobile_link_section,
  //           //   [name]: value,
  //           //   is_enable:
  //           //     type === "checkbox" && name === "is_enable"
  //           //       ? !prevJsonData?.theme_6?.home.section_6.mobile_link_section
  //           //           .is_enable
  //           //       : prevJsonData?.theme_6?.home.section_6.mobile_link_section
  //           //           .is_enable,
  //           // },
  //         },
  //       },
  //     },
  //   }));
  // };

  const handleChangeInputS3 = (
    e: any,
    isCard: boolean = false,
    index: number = 0
  ) => {
    const { value, name, type, checked, files } = e.target;

    setJsonData((prevJsonData: any) => {
      const updatedJson = _cloneDeep(prevJsonData); // Deep clone to avoid mutating Redux data

      // Ensure all parent objects exist
      if (!updatedJson.theme_6) updatedJson.theme_6 = {};
      if (!updatedJson.theme_6.home) updatedJson.theme_6.home = {};
      if (!updatedJson.theme_6.home.section_3)
        updatedJson.theme_6.home.section_3 = {};

      const section = updatedJson.theme_6.home.section_3;

      if (isCard) {
        if (!Array.isArray(section.cards)) {
          section.cards = [];
        }

        const cards = section.cards;

        // Default to passed index and name
        let actualIndex = index;
        let fieldName = name;

        // Check if name is in format "2_description"
        const match =
          typeof name === "string" ? name.match(/^(\d+)_(.+)$/) : null;
        if (match) {
          actualIndex = parseInt(match[1], 10);
          fieldName = match[2];
        }

        // Ensure the card exists
        if (!cards[actualIndex]) {
          cards[actualIndex] = {};
        }

        const newValue =
          type === "checkbox" ? checked : type === "file" ? files?.[0] : value;

        cards[actualIndex] = {
          ...cards[actualIndex],
          [fieldName]: newValue,
        };

        section.cards = cards;
      } else {
        // Handle normal inputs
        section[name] = type === "checkbox" ? checked : value;
      }

      return updatedJson;
    });
  };

  const handleChangeInputS4 = (
    e: any,
    isCard: boolean = false,
    index: number = 0
  ) => {
    console.log("e", e, "iscard", isCard, "ind", index);

    const { value, name, type, checked, files } = e.target;

    setJsonData((prevJsonData: any) => {
      const updatedJson = _cloneDeep(prevJsonData); // Deep clone to avoid mutating Redux data

      // Ensure all parent objects exist
      if (!updatedJson.theme_6) updatedJson.theme_6 = {};
      if (!updatedJson.theme_6.home) updatedJson.theme_6.home = {};
      if (!updatedJson.theme_6.home.section_4)
        updatedJson.theme_6.home.section_4 = {};

      const section = updatedJson.theme_6.home.section_4;

      if (isCard) {
        if (!Array.isArray(section.cards)) {
          section.cards = [];
        }

        const cards = section.cards;

        if (!cards[index]) {
          cards[index] = {};
        }

        const newValue =
          type === "checkbox" ? checked : type === "file" ? files?.[0] : value;

        cards[index] = {
          ...cards[index],
          [name]: newValue,
        };

        section.cards = cards;
      } else {
        // Handle non-card inputs
        section[name] = type === "checkbox" ? checked : value;
      }

      return updatedJson;
    });
  };
  const handleChangeInput2 = (
    e: any,
    isCard: boolean = false,
    index: number = 0
  ) => {
    const { value, name, type, checked, files } = e.target;

    setJsonData((prevJsonData: any) => {
      const updatedJson = _cloneDeep(prevJsonData); // safe deep clone

      // Ensure all parent objects exist
      if (!updatedJson.theme_6) updatedJson.theme_6 = {};
      if (!updatedJson.theme_6.home) updatedJson.theme_6.home = {};
      if (!updatedJson.theme_6.home.section_2)
        updatedJson.theme_6.home.section_2 = {};

      if (isCard) {
        if (!Array.isArray(updatedJson.theme_6.home.section_2.cards)) {
          updatedJson.theme_6.home.section_2.cards = [];
        }

        const cards = updatedJson.theme_6.home.section_2.cards;

        if (!cards[index]) {
          cards[index] = {};
        }

        const newValue =
          type === "checkbox" ? checked : type === "file" ? files?.[0] : value;

        cards[index] = {
          ...cards[index],
          [name]: newValue,
        };

        updatedJson.theme_6.home.section_2.cards = cards;
      } else {
        updatedJson.theme_6.home.section_2[name] =
          type === "checkbox" ? checked : value;
      }

      return updatedJson;
    });
  };

  const handleImageChange = (image: string) => {
    //Update the banner value in the JSON data
    setJsonData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_6: {
        ...prevJsonData.theme_6,
        home: {
          ...prevJsonData.theme_6.home,
          section_1: {
            ...prevJsonData.theme_6.home.section_1,
            banner: image,
          },
        },
      },
    }));
  };

  const saveJsonDataToFile = () => {
    dispatch(fetchWBDJsonList(editedData));
    dispatch(saveThemeJsonData(editedData));
  };

  useEffect(() => {
    setJsonData(jsonData);
  }, [jsonData]);

  useEffect(() => {
    // getWBDJsonList().then((res: any) => {
    //   console.log("logged web", res);
    //    dispatch(setHomeJsonList(JSON.parse(res.data.data)));
    // });
    getHomeJsonList();
    getSettingsWBDvedio().then((settingsData: any) => {
      setWBDVedio(settingsData?.WebsiteSettings?.wbd_video);
    });
  }, []);

  const icons = [
    "assets/icons/priorityicon1.png",
    "assets/icons/priorityicon2.png",
    "assets/icons/priorityicon3.png",
    "assets/icons/priorityicon4.png",
    "assets/icons/priorityicon5.png",
    "assets/icons/priorityicon6.png",
    "assets/icons/priorityicon7.png",
    "assets/icons/priorityicon8.png",
    "assets/icons/priorityicon9.png",
    "assets/icons/priorityicon10.png",
    "assets/icons/priorityicon11.png",
    "assets/icons/priorityicon12.png",
    "assets/icons/priorityicon13.png",
    "assets/icons/priorityicon14.png",
    "assets/icons/priorityicon15.png",
    "assets/icons/priorityicon16.png",
    "assets/icons/priorityicon17.png",
  ];

  useEffect(() => {
    const url = new URL(window.location.href);
    const token = url.searchParams.get("token");
    const host = window.location.hostname;
    // checks the token if its not in localhost
    console.log("called", token, "host", host);
    // if (host !== "localhost") {
    // if (token) {
    fetchThemeEdit(token).then((res: any) => {
      console.log("ress", res);

      if (res == false) {
        navigate("/");
      }
    });
    // } else {
    //   navigate("/");
    // }
    // }
  }, []);

  console.log("wed pag data", editedData);
  // console.log("wed pag ddd", editData);

  return (
    <>
      {/* <!-- Main Wrapper --> */}
      <div className="main-wrapper">
        {/* <!-- Header --> */}
        {/* <header className="header">
          <div className="container">
            <nav className="navbar navbar-expand-lg header-nav">
              <div className="navbar-header">
                <a id="mobile_btn" href="javascript:void(0);">
                  <span className="bar-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                  </span>
                </a>
                <div className="logo-main">
                  <a href="index.html" className="navbar-brand logo">
                    <span>
                      <img src="../../assets/img/laundryup/logo.svg" className="img-fluid" alt="Logo" />
                    </span>
                  </a>
                  <a href="index.html" className="logo-web">
                    <span>
                      <img src="../../assets/img/laundryup/logo-web.svg" className="img-fluid" alt="Logo" />
                    </span>
                  </a>
                </div>
                <a href="index.html" className="navbar-brand logo-small">
                  <img src="../../assets/img/laundryup/logo.svg" className="img-fluid" alt="Logo" />
                </a>
              </div>
              <div className="main-menu-wrapper">
                <div className="menu-header">
                  <a href="index.html" className="menu-logo">
                    <span>
                      <img src="../../assets/img/laundryup/logo.svg" className="img-fluid" alt="Logo" />
                    </span>
                  </a>
                  <a id="menu_close" className="menu-close" href="javascript:void(0);"> 
                    <i className="fas fa-times"></i>
                  </a>
                </div>
                <ul className="main-nav">
                  <li className="active">
                    <a href="index.html">Home</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);">Pricing</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);">Area Covered</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);">Blog</a>
                  </li>
                  <li className="login-link">
                    <a href="javascript:void(0);">Sign In</a>
                  </li>
                </ul>
              </div>
              <ul className="nav header-navbar-rht">
                <li className="nav-item cart-item">
                  <div className="cart-flex">
                    <div className="cart-icon">
                      <img src="../../assets/img/laundryup/icons/cart-icon.svg" alt="Icon" />
                    </div>
                    <div className="cart-text">
                      <p>items : 0</p>
                      <h6>£0.00</h6>
                    </div>
                  </div>
                </li>
                <li className="nav-item">
                  <a href="javascript:void(0);" className="nav-link header-login">
                    <i className="ti ti-user"></i> Sign In
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </header> */}
        {/* <!-- /Header --> */}

        {/* <!-- Hero --> */}
        <div className="section-editor">
          <a
            href="javascript:void(0);"
            data-bs-toggle="modal"
            data-bs-target="#bannerEditmodals"
            className="section-editor-icon"
          >
            <i className="fas fa-edit"></i>
          </a>
          <div
            className="hero-section"
            style={{ position: "relative", overflow: "hidden" }}
          >
            <img
              src={jsonData?.theme_6?.home?.section_1?.banner}
              alt=""
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                zIndex: -1,
              }}
            />
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-12 aos" data-aos="fade-up">
                  <div className="hero-content">
                    <h1>{jsonData?.theme_6?.home?.section_1?.title}</h1>
                    <p>{jsonData?.theme_6?.home?.section_1?.sub_heading_top}</p>
                    {/* <form onSubmit={handlePinCodeSubmit(submitPostalForm)}>
                            <div className={`${checkWithNewPin == false ? "d-none" : ""}`}>
                            <small className="text-danger postvalidation">
                                {pinCodeFormError.pinCode?.message}
                            </small>
                            <div className="hero-form">
                                <div className="hero-input">
                                    <div className="postcodeform">
                                        <Controller
                                        name="pinCode"
                                        control={pinCodeFormControl}
                                        render={({ field }) => (
                                            <input
                                            type="text"
                                            id="postcode-input"
                                            {...field}
                                            placeholder={
                                                homedata?.theme_3?.home?.section_1?.btn_group
                                                ?.btn1?.placeholder
                                            } 
                                            className={`ui-autocomplete-input ${
                                                pinCodeFormError.pinCode ? "invalid" : ""
                                            }`}
                                            onChange={handleChange}
                                            autoComplete="off"
                                            />
                                        )}
                                        />
                                        <div className="dropdown">
                                        {postalCodeList
                                            .filter((item: any) => {
                                            const searchTerm = postalCodeValue.toLowerCase();
                                            const mainValue = item.postcode.toLowerCase();

                                            return (
                                                searchTerm &&
                                                mainValue.startsWith(searchTerm) &&
                                                mainValue !== searchTerm
                                            );
                                            })
                                            .slice(0, 10)
                                            .map((item: any) => (
                                            <div
                                                onClick={() => onSearch(item.postcode)}
                                                className="dropdown-row"
                                                key={item.postcode}
                                            >
                                                <i className="fas fa-map-marker-alt"></i>
                                                {item.postcode}
                                            </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="hero-btn">
                                <button type="submit" className="btn btn-secondary">
                                    Book Now <i className="ti ti-arrow-narrow-right"></i>
                                </button>
                                </div>
                            </div>
                            </div>
                        </form> */}
                    <form>
                      {/* <div
                            className={`adrsselectform ${
                                checkWithNewPin == true ? "d-none" : ""
                            }`}
                            >
                            <small className="text-danger postvalidation">
                                {addressFormError.address?.message}
                            </small> */}
                      <div className="adrsselectdd">
                        <Controller
                          name="address"
                          control={addressFormControl}
                          render={({ field }) => (
                            <Select
                              placeholder="Select address..."
                              {...field}
                              value={selectedAddress}
                              className={`${
                                addressFormError.address ? "invalid" : ""
                              }`}
                              onChange={handleAddressChange}
                              onFocus={() => {
                                if (
                                  getValuesAddressForm("address").value == ""
                                ) {
                                  addressFormSetError("address", {
                                    type: "server",
                                    message: "Address is required to proceed",
                                  });
                                } else {
                                  clearErrors();
                                }
                              }}
                              options={areaOptions}
                            />
                          )}
                        />

                        {/* <input
                                type="button"
                                value="Continue"
                                className="btn btn-secondary"
                                onClick={submitAddressChange}
                                /> */}
                        <button
                          type="button"
                          className="btn-secondary"
                          onClick={submitAddressChange}
                          style={{
                            backgroundColor: `#${jsonData?.theme_6?.home?.section_1?.bg_color}`,
                            color: `#${jsonData?.theme_6?.home?.section_1?.color}`,
                          }}
                        >
                          {jsonData?.theme_6?.home?.section_1?.text}{" "}
                          <i className="ti ti-arrow-narrow-right"></i>
                        </button>
                      </div>
                      {/* <div className="adrsselect-or text-white">OR</div>
                            <div className="adrsselect-link">
                                <a
                                className="cursor-pointer text-white"
                                onClick={() => {
                                    setCheckWithNewPin(true);
                                }}
                                >
                                Check with another Postcode
                                </a>
                            </div> */}
                      {/* </div> */}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- /Hero --> */}

        <div
          className="modal fade"
          id="bannerEditmodals"
          data-bs-keyboard="false"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Home Section Banner Theme Edit</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">
                    Title <small>(max 250 char)</small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="title"
                    // defaultValue="Professional Laundry Service at WBD"
                    value={editedData?.theme_6?.home?.section_1?.title}
                    onChange={handleChangeInput}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Sub Title <small>(max 250 char)</small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="sub_heading_top"
                    // defaultValue="Twice a week. Hassle-free. Trusted at the Studio"
                    value={
                      editedData?.theme_6?.home?.section_1?.sub_heading_top
                    }
                    onChange={handleChangeInput}
                  />
                </div>
                <div className="mb-3">
                  <div className="row">
                    <div className="col">
                      <div className="mb-3">
                        <label className="form-label">Button</label>
                        <input
                          type="text"
                          className="form-control"
                          name="text"
                          // defaultValue="Book Now"
                          value={editedData?.theme_6?.home?.section_1?.text}
                          onChange={handleChangeInput}
                        />
                      </div>
                    </div>
                    <div className="col">
                      <div className="mb-3">
                        <label className="form-label">Background</label>
                        <div className="input-group color-change">
                          <input
                            type="text"
                            className="form-control"
                            name="bg_color"
                            // defaultValue="259fed"
                            value={
                              editedData?.theme_6?.home?.section_1?.bg_color
                            }
                            onChange={handleChangeInput}
                          />
                          <div
                            className="p-colorpicker p-component p-colorpicker-overlay"
                            data-pc-name="colorpicker"
                          >
                            {/* <input
                              type="text"
                              readOnly
                              className="p-colorpicker-preview p-inputtext"
                              data-pc-section="input"
                              style={{ backgroundColor: "rgb(37, 160, 237)" }}
                            /> */}
                            <ColorPicker
                              name="bg_color"
                              onChange={(e) => {
                                handleChangeInput(e);
                              }}
                              format="hex"
                              value={
                                editedData?.theme_6?.home?.section_1?.bg_color
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="mb-3">
                        <label className="form-label">Color</label>
                        <div className="input-group color-change">
                          <input
                            type="text"
                            className="form-control"
                            name="color"
                            // defaultValue="ffffff"
                            value={editedData?.theme_6?.home?.section_1?.color}
                            onChange={handleChangeInput}
                          />
                          <div
                            className="p-colorpicker p-component p-colorpicker-overlay"
                            data-pc-name="colorpicker"
                          >
                            <ColorPicker
                              name="color"
                              onChange={(e) => {
                                handleChangeInput(e);
                              }}
                              format="hex"
                              value={
                                editedData?.theme_6?.home?.section_1?.color
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Banner Section */}
                <div className="mb-3">
                  <div className="row">
                    <div className="col-md-12">
                      <label className="form-label">Banner</label>
                      <div className="img-bg active">
                        <img
                          // src={previewImage || wing4}
                          src={editedData?.theme_6?.home?.section_1?.banner}
                          alt="Banner"
                          className="img-fluid"
                        />
                      </div>

                      {/*   <div className="img-options">
                        <div className="swiper homejson-slider">
                          <div className="swiper-wrapper">
                            {["heroimg.png", "heroimg.png"].map(
                              (img, index) => (
                                <div className="swiper-slide" key={index}>
                                  <div className="img-option">
                                    <img
                                      src={`assets/img/home/${img}`}
                                      alt="Hero Image"
                                      className="img-fluid"
                                    />
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                          <div className="swiper-button-prev"></div>
                          <div className="swiper-button-next"></div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>

                {/* Upload Image/Video */}
                <div className="mb-3">
                  <label className="form-label">Upload Image</label>
                  <input
                    type="file"
                    accept="image/*, video/*"
                    className="form-control"
                    name="banner_two"
                    onChange={(e: any) => updateImageSectionOne(e)}
                  />
                </div>

                {/* <div className="add-section">
                  <div className="row">
                    <div className="col text-center">
                      Add Card<i className="fas fa-plus-square ms-2"></i>
                    </div>
                  </div>
                </div> */}

                <div className="mb-3">
                  <button
                    type="submit"
                    data-bs-dismiss="modal"
                    className="btn primary-btn"
                    onClick={() => {
                      saveJsonDataToFile();
                    }}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Work --> */}
        <div className="section-editor">
          <a
            href="javascript:void(0);"
            data-bs-toggle="modal"
            data-bs-target="#how-works"
            className="section-editor-icon"
          >
            <i className="fas fa-edit"></i>
          </a>

          <div className="work-section">
            <div className="work-shape">
              <img
                src={shape1}
                className="shape-01 aos"
                data-aos="fade-up"
                alt="Shape"
              />
              <img
                src={shape2}
                className="shape-02 aos"
                data-aos="zoom-in"
                alt="Shape"
              />
            </div>
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6 aos" data-aos="fade-up">
                  <div className="work-img">
                    <img
                      src={jsonData?.theme_6?.home?.section_2?.banner}
                      className="img-fluid"
                      alt="Work"
                    />
                    {/* <a href="javascript:void(0);">
                        <i className="fa fa-play"></i>
                    </a> */}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div
                    className="section-header text-start aos"
                    data-aos="fade-up"
                  >
                    <h2
                      style={{
                        color: `#${jsonData?.theme_6?.home?.section_2?.title_color}`,
                      }}
                    >
                      {jsonData?.theme_6?.home?.section_2?.title}
                      <img src={headingIcon} />
                    </h2>
                    <p
                      style={{
                        color: `#${jsonData?.theme_6?.home?.section_2?.sub_title_color}`,
                      }}
                    >
                      {jsonData?.theme_6?.home?.section_2?.sub_heading_top}
                    </p>
                  </div>
                  <div className="row">
                    {jsonData?.theme_6?.home?.section_2?.cards?.map(
                      (val: any, index: any) => {
                        return (
                          <div
                            className="col-md-6 d-flex aos"
                            data-aos="fade-up"
                            key={index}
                          >
                            <div className="work-grid w-100">
                              <div className="work-icon">
                                <img src={val?.image} alt="Icon" />
                                <span>{`0${index + 1}`}</span>
                              </div>
                              <div className="work-text">
                                <h4
                                  style={{
                                    color: `#${val?.title_color}`,
                                  }}
                                >
                                  {val?.title}
                                </h4>
                                <p
                                  style={{
                                    color: `#${val?.sub_title_color}`,
                                  }}
                                >
                                  {val?.description}
                                </p>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    )}
                    {/* <div className="col-md-6 d-flex aos" data-aos="fade-up">
                      <div className="work-grid w-100">
                        <div className="work-icon">
                          <img src={work2} alt="Icon" />
                          <span>02</span>
                        </div>
                        <div className="work-text">
                          <h4>Step 2</h4>
                          <p>
                            Pickup & Drop location to : WB Studios, Leavesden
                            Park, Watford.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 d-flex aos" data-aos="fade-up">
                      <div className="work-grid w-100">
                        <div className="work-icon">
                          <img src={work3} alt="Icon" />
                          <span>03</span>
                        </div>
                        <div className="work-text">
                          <h4>Step 3</h4>
                          <p>Choose a time slot – Tuesdays or Fridays only.</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 d-flex aos" data-aos="fade-up">
                      <div className="work-grid w-100">
                        <div className="work-icon">
                          <img src={work4} alt="Icon" />
                          <span>04</span>
                        </div>
                        <div className="work-text">
                          <h4>Step 4</h4>
                          <p>
                            Pay a fixed £5 booking fee to confirm your order.
                          </p>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="how-works"
          data-bs-keyboard="false"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">How It Works</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <div className="edit-section">
                  <div className="mb-3">
                    <label className="form-label">
                      Title <small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      defaultValue="How It Works"
                      onChange={handleChangeInput2}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">
                      Sub Title <small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="sub_heading_top"
                      defaultValue="A simple 4-step process designed exclusively for Warner Brothers"
                      onChange={handleChangeInput2}
                    />
                  </div>
                  <div className="row">
                    <div className="col-md">
                      <div className="mb-3">
                        <label className="form-label">header 1 Color</label>
                        <div className="input-group color-change">
                          <input
                            type="text"
                            className="form-control"
                            name="title_color"
                            // defaultValue="259fed"
                            value={
                              editedData?.theme_6?.home?.section_2?.title_color
                            }
                            onChange={(e) => {
                              handleChangeInput2(e);
                            }}
                          />
                          <div
                            className="p-colorpicker p-component p-colorpicker-overlay"
                            data-pc-name="colorpicker"
                          >
                            <ColorPicker
                              name="title_color"
                              onChange={(e) => {
                                handleChangeInput2(e);
                              }}
                              format="hex"
                              value={
                                editedData?.theme_6?.home?.section_2
                                  ?.title_color
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md">
                      <div className="mb-3">
                        <label className="form-label">paragraph Color</label>
                        <div className="input-group color-change">
                          <input
                            type="text"
                            className="form-control"
                            name="sub_title_color"
                            // defaultValue="259fed"
                            value={
                              editedData?.theme_6?.home?.section_2
                                ?.sub_title_color
                            }
                            onChange={(e) => {
                              handleChangeInput2(e);
                            }}
                          />
                          <div
                            className="p-colorpicker p-component p-colorpicker-overlay"
                            data-pc-name="colorpicker"
                          >
                            <ColorPicker
                              name="sub_title_color"
                              onChange={(e) => {
                                handleChangeInput2(e);
                              }}
                              format="hex"
                              value={
                                editedData?.theme_6?.home?.section_2
                                  ?.sub_title_color
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <div className="row">
                      <div className="col-md-12">
                        <label className="form-label">how its work image</label>
                        <div className="img-bg active">
                          {/* {previewImage ? (
                            <img
                              src={previewImage}
                              alt="Preview"
                              className="img-fluid"
                              style={{
                                width: "200px",
                                height: "auto",
                                borderRadius: "10px",
                              }}
                            />
                          ) : ( */}
                          <img
                            src={editedData?.theme_6?.home?.section_2?.banner}
                            alt="Default"
                            className="img-fluid"
                            style={{
                              width: "200px",
                              height: "auto",
                              borderRadius: "10px",
                            }}
                          />
                          {/* )} */}
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Upload Image</label>
                        <input
                          type="file"
                          accept="image/png, image/jpeg"
                          className="form-control"
                          name="image"
                          onChange={updateImageSection2}
                        />
                      </div>
                    </div>
                  </div>
                  <ul className="nav nav-tabs">
                    <Swiper
                      spaceBetween={15}
                      navigation={true}
                      modules={[Navigation]}
                      slidesPerView={3}
                      breakpoints={{
                        640: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                      }}
                      className="homejson-slider"
                    >
                      {bannerData4.map((item, index) => (
                        <SwiperSlide key={index}>
                          <li className="nav-item nav-option">
                            <a
                              className={`nav-link ${
                                activeTab === index ? "active" : ""
                              }`}
                              onClick={() => setActiveTab(index)}
                            >
                              {item.title}
                            </a>
                          </li>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </ul>

                  <div className="tab-content">
                    {bannerData4.map((item, index) => (
                      <div
                        key={index}
                        className={`tab-pane fade ${
                          activeTab === index ? "show active" : ""
                        }`}
                      >
                        <div className="row">
                          <div className="col-md-12">
                            <div className="img-bg active text-center mb-3">
                              <img
                                src={item.bg}
                                alt="Hero Banner"
                                className="img-fluid"
                                style={{
                                  maxHeight: "300px",
                                  objectFit: "cover",
                                }}
                              />
                            </div>

                            <Swiper
                              spaceBetween={15}
                              navigation={true}
                              modules={[Navigation]}
                              breakpoints={{
                                640: { slidesPerView: 2 },
                                768: { slidesPerView: 3 },
                                1024: { slidesPerView: 4 },
                              }}
                              className="homejson-slider"
                            >
                              {item.thumbnails.map((thumb, thumbIndex) => (
                                <SwiperSlide key={thumbIndex}>
                                  <div
                                    className="img-option"
                                    onClick={() => {
                                      handleImageClick4(index, thumb);
                                      handleChangeInput2(
                                        {
                                          target: {
                                            value: thumb,
                                            name: "image",
                                          },
                                        },
                                        true,
                                        activeTab
                                      );
                                    }}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <img
                                      src={thumb}
                                      alt={`Thumb ${thumbIndex + 1}`}
                                      className="img-fluid"
                                      style={{
                                        borderRadius: "8px",
                                        border: "2px solid #ccc",
                                      }}
                                    />
                                  </div>
                                </SwiperSlide>
                              ))}
                            </Swiper>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Card Title <small>(max 250 char)</small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="title"
                    // defaultValue="Delivery Days"
                    value={
                      editedData?.theme_6?.home?.section_2?.cards?.[activeTab]
                        ?.title
                    }
                    onChange={(e) => handleChangeInput2(e, true, activeTab)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Card Description <small>(max 250 char)</small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="description"
                    // defaultValue="Delivery Days"
                    value={
                      editedData?.theme_6?.home?.section_2?.cards?.[activeTab]
                        ?.description
                    }
                    onChange={(e) => handleChangeInput2(e, true, activeTab)}
                  />
                </div>

                <div className="row">
                  <div className="col-md">
                    <div className="mb-3">
                      <label className="form-label">Card Title Color</label>
                      <div className="input-group color-change">
                        <input
                          type="text"
                          className="form-control"
                          name="title_color"
                          // defaultValue="259fed"
                          value={
                            editedData?.theme_6?.home?.section_2?.cards?.[
                              activeTab
                            ]?.title_color
                          }
                          onChange={(e) =>
                            handleChangeInput2(e, true, activeTab)
                          }
                        />
                        <div
                          className="p-colorpicker p-component p-colorpicker-overlay"
                          data-pc-name="colorpicker"
                        >
                          <ColorPicker
                            name="title_color"
                            onChange={(e) =>
                              handleChangeInput2(e, true, activeTab)
                            }
                            format="hex"
                            value={
                              editedData?.theme_6?.home?.section_2?.cards?.[
                                activeTab
                              ]?.title_color
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">Card Description Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="sub_title_color"
                        // defaultValue="259fed"
                        value={
                          editedData?.theme_6?.home?.section_2?.cards?.[
                            activeTab
                          ]?.sub_title_color
                        }
                        onChange={(e) => handleChangeInput2(e, true, activeTab)}
                      />
                      <div
                        className="p-colorpicker p-component p-colorpicker-overlay"
                        data-pc-name="colorpicker"
                      >
                        <ColorPicker
                          name="sub_title_color"
                          onChange={(e) =>
                            handleChangeInput2(e, true, activeTab)
                          }
                          format="hex"
                          value={
                            editedData?.theme_6?.home?.section_2?.cards?.[
                              activeTab
                            ]?.sub_title_color
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="row">
                  <div className="col-md">
                    <div className="mb-3">
                      <label className="form-label">
                        Card Description Color
                      </label>
                      <div className="input-group color-change">
                        <input
                          type="text"
                          className="form-control"
                          name="title_color"
                          // defaultValue="259fed"
                          value={
                            editedData?.theme_6?.home?.section_2?.title_color
                          }
                          disabled={true}
                        />
                        <div
                          className="p-colorpicker p-component p-colorpicker-overlay"
                          data-pc-name="colorpicker"
                        >
                          <ColorPicker
                            name="title_color"
                            onChange={(e) => {
                              handleChangeInput2(e);
                            }}
                            format="hex"
                            value={
                              editedData?.theme_6?.home?.section_2?.title_color
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md">
                    <div className="mb-3">
                      <label className="form-label">paragraph Color</label>
                      <div className="input-group color-change">
                        <input
                          type="text"
                          className="form-control"
                          name="sub_title_color"
                          // defaultValue="259fed"
                          value={
                            editedData?.theme_6?.home?.section_4
                              ?.sub_title_color
                          }
                          disabled={true}
                        />
                        <div
                          className="p-colorpicker p-component p-colorpicker-overlay"
                          data-pc-name="colorpicker"
                        >
                          <ColorPicker
                            name="sub_title_color"
                            onChange={(e) => {
                              handleChangeInput2(e);
                            }}
                            format="hex"
                            value={
                              editedData?.theme_6?.home?.section_4
                                ?.sub_title_color
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}

                {/* <div className="edit-section">
                  <div className="row">
                    <div className="mb-3">
                      <label className="form-label">Upload Image</label>
                      <input
                        type="file"
                        accept="image/png, image/jpeg"
                        className="form-control"
                        name="image"
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">
                      Title <small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="collection_title"
                      defaultValue="Step 1"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Description</label>
                    <input
                      type="text"
                      className="form-control"
                      name="collection_paragraph"
                      defaultValue="Select “Quick” for simple bundles or “Itemized” to choose each item."
                    />
                  </div>

                  <div className="row">
                    <div className="col-md">
                      <div className="mb-3">
                        <label className="form-label">Title Color</label>
                        <div className="input-group color-change">
                          <input
                            type="text"
                            className="form-control"
                            name="bg_color"
                            defaultValue="259fed"
                          />
                          <div
                            className="p-colorpicker p-component p-colorpicker-overlay"
                            data-pc-name="colorpicker"
                          >
                            <input
                              type="text"
                              readOnly
                              className="p-colorpicker-preview p-inputtext"
                              data-pc-section="input"
                              style={{ backgroundColor: "rgb(37, 160, 237)" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md">
                      <div className="mb-3">
                        <label className="form-label">paragraph Color</label>
                        <div className="input-group color-change">
                          <input
                            type="text"
                            className="form-control"
                            name="bg_color"
                            defaultValue="259fed"
                          />
                          <div
                            className="p-colorpicker p-component p-colorpicker-overlay"
                            data-pc-name="colorpicker"
                          >
                            <input
                              type="text"
                              readOnly
                              className="p-colorpicker-preview p-inputtext"
                              data-pc-section="input"
                              style={{ backgroundColor: "rgb(37, 160, 237)" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                {/* Banner Section */}

                <div className="mb-3">
                  <button
                    type="submit"
                    data-bs-dismiss="modal"
                    className="btn primary-btn"
                    onClick={() => {
                      saveJsonDataToFile();
                    }}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- /Work --> */}

        {/* <!-- Order --> */}
        <div className="section-editor">
          <a
            href="javascript:void(0);"
            data-bs-toggle="modal"
            data-bs-target="#order-type"
            className="section-editor-icon"
          >
            <i className="fas fa-edit"></i>
          </a>
          <div className="order-section">
            <div className="container">
              <div className="row">
                <div className="col-md-12 aos" data-aos="fade-up">
                  <div className="section-header">
                    <h2
                      style={{
                        color: `#${jsonData?.theme_6?.home?.section_3?.title_color}`,
                      }}
                    >
                      {jsonData?.theme_6?.home?.section_3?.title}
                      <img src={headingIcon} />
                    </h2>
                    <p
                      style={{
                        color: `#${jsonData?.theme_6?.home?.section_3?.sub_title_color}`,
                      }}
                    >
                      {jsonData?.theme_6?.home?.section_3?.sub_heading_top}
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                {jsonData?.theme_6?.home?.section_3?.cards?.map(
                  (val: any, index: number) => (
                    <div
                      className="col-md-6 d-flex aos"
                      data-aos="fade-up"
                      key={index}
                    >
                      <div className="order-grid w-100">
                        <div className="ribbone">
                          <span
                            style={{
                              backgroundColor: `#${val?.flat_rate_bg_color}`,
                              color: `#${val?.flat_color}`,
                            }}
                          >
                            {val?.flat_rate}
                          </span>
                        </div>
                        <div className="order-text">
                          <h4 style={{ color: `#${val?.title_color}` }}>
                            {val?.title}
                          </h4>

                          {Array.isArray(val?.description) &&
                            val.description.map((desc: string, idx: number) => (
                              <p
                                key={idx}
                                style={{ color: `#${val?.description_color}` }}
                              >
                                <i className="ti ti-circle-check-filled"></i>
                                {desc}
                              </p>
                            ))}
                        </div>
                        <div className="order-img">
                          <img src={val?.image} alt="Order" />
                        </div>
                      </div>
                    </div>
                  )
                )}

                {/* <div className="col-md-6 d-flex aos" data-aos="fade-up">
                  <div className="order-grid w-100">
                    <div className="ribbone">
                      <span>Per Item</span>
                    </div>
                    <div className="order-text">
                      <h4>Itemized Order</h4>
                      <p>
                        <i className="ti ti-circle-check-filled"></i> Pay per
                        item
                      </p>
                      <p>
                        <i className="ti ti-circle-check-filled"></i> WB Studio
                        pickup, same as Quick Order
                      </p>
                      <p>
                        <i className="ti ti-circle-check-filled"></i> Select
                        each item
                      </p>
                      <p>
                        <i className="ti ti-circle-check-filled"></i> Add
                        special care notes
                      </p>
                      <p>
                        <i className="ti ti-circle-check-filled"></i> Ideal for
                        dry cleaning
                      </p>
                    </div>
                    <div className="order-img">
                      <img src={order2} alt="Order" />
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="order-type"
          data-bs-keyboard="false"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Which Order Type Theme Edit</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <div className="edit-section">
                  <div className="mb-3">
                    <label className="form-label">
                      Title <small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      defaultValue="Which Order Type Suits You?"
                      value={editedData?.theme_6?.home?.section_3?.title}
                      onChange={handleChangeInputS3}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">
                      Sub Title <small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="sub_heading_top"
                      defaultValue="Whether you're in a hurry or need custom care, we've got you covered"
                      value={
                        editedData?.theme_6?.home?.section_3?.sub_heading_top
                      }
                      onChange={handleChangeInputS3}
                    />
                  </div>
                  <div className="row">
                    <div className="col-md">
                      <div className="mb-3">
                        <label className="form-label">Header Color</label>
                        <div className="input-group color-change">
                          <input
                            type="text"
                            className="form-control"
                            name="title_color"
                            // defaultValue="259fed"
                            value={
                              editedData?.theme_6?.home?.section_3?.title_color
                            }
                            onChange={(e) => {
                              handleChangeInputS3(e);
                            }}
                          />
                          <div
                            className="p-colorpicker p-component p-colorpicker-overlay"
                            data-pc-name="colorpicker"
                          >
                            <ColorPicker
                              name="title_color"
                              onChange={(e) => {
                                handleChangeInputS3(e);
                              }}
                              format="hex"
                              value={
                                editedData?.theme_6?.home?.section_3
                                  ?.title_color
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md">
                      <div className="mb-3">
                        <label className="form-label">paragraph Color</label>
                        <div className="input-group color-change">
                          <input
                            type="text"
                            className="form-control"
                            name="sub_title_color"
                            // defaultValue="259fed"
                            value={
                              editedData?.theme_6?.home?.section_3
                                ?.sub_title_color
                            }
                            onChange={(e) => {
                              handleChangeInputS3(e);
                            }}
                          />
                          <div
                            className="p-colorpicker p-component p-colorpicker-overlay"
                            data-pc-name="colorpicker"
                          >
                            <ColorPicker
                              name="sub_title_color"
                              onChange={(e) => {
                                handleChangeInputS3(e);
                              }}
                              format="hex"
                              value={
                                editedData?.theme_6?.home?.section_3
                                  ?.sub_title_color
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="edit-section">
                  <div className="tab-content">
                    <ul className="nav nav-tabs">
                      <Swiper
                        spaceBetween={15}
                        navigation={true}
                        modules={[Navigation]}
                        breakpoints={{
                          640: { slidesPerView: 1 },
                          768: { slidesPerView: 2 },
                          1024: { slidesPerView: 3 },
                        }}
                        className="homejson-slider"
                      >
                        {bannerData.map((item, index) => (
                          <SwiperSlide key={index}>
                            <li className="nav-item nav-option">
                              <a
                                className={`nav-link ${
                                  activeTab === index ? "active" : ""
                                }`}
                                onClick={() => setActiveTab(index)}
                              >
                                {item.title}
                              </a>
                            </li>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </ul>
                    <div className="mb-3">
                      <label className="form-label">
                        Title <small>(max 250 char)</small>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        // defaultValue="Quick Order"
                        value={
                          editedData?.theme_6?.home?.section_3?.cards?.[
                            activeTab
                          ]?.title
                        }
                        onChange={(e) =>
                          handleChangeInputS3(e, true, activeTab)
                        }
                      />
                    </div>
                    {/* <div className="mb-3">
                      <label className="form-label">
                        Sub Title <small>(max 250 char)</small>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="sub_title"
                        // defaultValue="Flat-rate price per load"
                        value={
                          editedData?.theme_6?.home?.section_3?.cards?.[
                            activeTab
                          ]?.sub_title
                        }
                        onChange={(e) =>
                          handleChangeInputS3(e, true, activeTab)
                        }
                      />
                    </div> */}
                    <div className="mb-3">
                      <label className="form-label">
                        Flat Rate<small>(max 100 char)</small>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="flat_rate"
                        defaultValue="Flat Rate"
                        value={
                          editedData?.theme_6?.home?.section_3?.cards?.[
                            activeTab
                          ]?.flat_rate
                        }
                        onChange={(e) =>
                          handleChangeInputS3(e, true, activeTab)
                        }
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Description</label>
                      {/* <input
                        type="text"
                        className="form-control"
                        name="description"
                        // defaultValue="Good for daily wear like shirts & trousers Same WB Studio pickup No item selection required Faster checkout."
                        onChange={(e) =>
                          handleChangeInputS3(e, true, activeTab)
                        }
                        value={
                          editedData?.theme_6?.home?.section_3?.cards?.[
                            activeTab
                          ]?.description
                        }
                      /> */}
                      <Chips
                        className="form-control"
                        value={
                          Array.isArray(
                            editedData?.theme_6?.home?.section_3?.cards?.[
                              activeTab
                            ]?.description
                          )
                            ? editedData?.theme_6?.home?.section_3?.cards?.[
                                activeTab
                              ]?.description
                            : []
                        }
                        onChange={(e) => {
                          console.log(e, "chips value");

                          // Manually construct a pseudo event
                          const syntheticEvent = {
                            target: {
                              name: `${activeTab}_description`, // inline name with index
                              value: e.value,
                              type: "text", // assume chips return text[]
                            },
                          };

                          handleChangeInputS3(syntheticEvent, true);
                        }}
                      />
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">Title Color</label>
                          <div className="input-group color-change">
                            <input
                              type="text"
                              className="form-control"
                              name="title_color"
                              value={
                                editedData?.theme_6?.home?.section_3?.cards?.[
                                  activeTab
                                ]?.title_color
                              }
                              onChange={(e) => {
                                handleChangeInputS3(e, true, activeTab);
                              }}
                              // defaultValue="ffffff"
                              // value={
                              //   editedData?.theme_6?.home?.section_1
                              //     ?.title_color
                              // }
                            />
                            <div
                              className="p-colorpicker p-component p-colorpicker-overlay"
                              data-pc-name="colorpicker"
                            >
                              <ColorPicker
                                name="title_color"
                                onChange={(e) => {
                                  handleChangeInputS3(e, true, activeTab);
                                }}
                                format="hex"
                                // value={
                                //   editedData?.theme_6?.home?.section_1
                                //     ?.btn_group?.btn1?.color
                                // }
                                value={
                                  editedData?.theme_6?.home?.section_3?.cards?.[
                                    activeTab
                                  ]?.title_color
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">Sub Title Color</label>
                          <div className="input-group color-change">
                            <input
                              type="text"
                              className="form-control"
                              name="sub_title_color"
                              // defaultValue="ffffff"
                              // value={
                              //   editedData?.theme_6?.home?.section_1
                              //     ?.title_color
                              // }
                              value={
                                editedData?.theme_6?.home?.section_3?.cards?.[
                                  activeTab
                                ]?.sub_title_color
                              }
                            />
                            <div
                              className="p-colorpicker p-component p-colorpicker-overlay"
                              data-pc-name="colorpicker"
                            >
                              <ColorPicker
                                name="sub_title_color"
                                onChange={(e) => {
                                  handleChangeInputS3(e, true, activeTab);
                                }}
                                format="hex"
                                // value={
                                //   editedData?.theme_6?.home?.section_1
                                //     ?.btn_group?.btn1?.color
                                // }
                                value={
                                  editedData?.theme_6?.home?.section_3?.cards?.[
                                    activeTab
                                  ]?.sub_title_color
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div> */}
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">Flat Rate Color</label>
                          <div className="input-group color-change">
                            <input
                              type="text"
                              className="form-control"
                              name="flat_color"
                              // defaultValue="ffffff"
                              // value={
                              //   editedData?.theme_6?.home?.section_1
                              //     ?.title_color
                              // }
                              value={
                                editedData?.theme_6?.home?.section_3?.cards?.[
                                  activeTab
                                ]?.flat_color
                              }
                              onChange={(e) => {
                                handleChangeInputS3(e, true, activeTab);
                              }}
                            />
                            <div
                              className="p-colorpicker p-component p-colorpicker-overlay"
                              data-pc-name="colorpicker"
                            >
                              <ColorPicker
                                name="flat_color"
                                onChange={(e) => {
                                  handleChangeInputS3(e, true, activeTab);
                                }}
                                format="hex"
                                // value={
                                //   editedData?.theme_6?.home?.section_1
                                //     ?.btn_group?.btn1?.color
                                // }
                                value={
                                  editedData?.theme_6?.home?.section_3?.cards?.[
                                    activeTab
                                  ]?.flat_color
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">
                            Flat Rate background Color
                          </label>
                          <div className="input-group color-change">
                            <input
                              type="text"
                              className="form-control"
                              name="flat_rate_bg_color"
                              // defaultValue="ffffff"
                              // value={
                              //   editedData?.theme_6?.home?.section_1
                              //     ?.title_color
                              // }
                              value={
                                editedData?.theme_6?.home?.section_3?.cards?.[
                                  activeTab
                                ]?.flat_rate_bg_color
                              }
                              onChange={(e) => {
                                handleChangeInputS3(e, true, activeTab);
                              }}
                            />
                            <div
                              className="p-colorpicker p-component p-colorpicker-overlay"
                              data-pc-name="colorpicker"
                            >
                              <ColorPicker
                                name="flat_rate_bg_color"
                                onChange={(e) => {
                                  handleChangeInputS3(e, true, activeTab);
                                }}
                                format="hex"
                                // value={
                                //   editedData?.theme_6?.home?.section_1
                                //     ?.btn_group?.btn1?.color
                                // }
                                value={
                                  editedData?.theme_6?.home?.section_3?.cards?.[
                                    activeTab
                                  ]?.flat_rate_bg_color
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">
                            Description Color
                          </label>
                          <div className="input-group color-change">
                            <input
                              type="text"
                              className="form-control"
                              name="description_color"
                              // defaultValue="ffffff"
                              // value={
                              //   editedData?.theme_6?.home?.section_1
                              //     ?.title_color
                              // }
                              value={
                                editedData?.theme_6?.home?.section_3?.cards?.[
                                  activeTab
                                ]?.description_color
                              }
                              onChange={(e) => {
                                handleChangeInputS3(e, true, activeTab);
                              }}
                            />
                            <div
                              className="p-colorpicker p-component p-colorpicker-overlay"
                              data-pc-name="colorpicker"
                            >
                              <ColorPicker
                                name="description_color"
                                onChange={(e) => {
                                  handleChangeInputS3(e, true, activeTab);
                                }}
                                format="hex"
                                // value={
                                //   editedData?.theme_6?.home?.section_1
                                //     ?.btn_group?.btn1?.color
                                // }
                                value={
                                  editedData?.theme_6?.home?.section_3?.cards?.[
                                    activeTab
                                  ]?.description_color
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Banner</label>

                      <div className="tab-content">
                        {section3Icons.map((item, index) => (
                          <div
                            key={index}
                            className={`tab-pane fade ${
                              activeTab === index ? "show active" : ""
                            }`}
                          >
                            <div className="row">
                              <div className="col-md-12">
                                <div className="img-bg active text-center mb-3">
                                  <img
                                    src={item.bg}
                                    alt="Hero Banner"
                                    className="img-fluid"
                                    style={{
                                      maxHeight: "300px",
                                      objectFit: "cover",
                                    }}
                                  />
                                </div>

                                <Swiper
                                  spaceBetween={15}
                                  navigation={true}
                                  modules={[Navigation]}
                                  breakpoints={{
                                    640: { slidesPerView: 2 },
                                    768: { slidesPerView: 3 },
                                    1024: { slidesPerView: 4 },
                                  }}
                                  className="homejson-slider"
                                >
                                  {item.thumbnails.map((thumb, thumbIndex) => (
                                    <SwiperSlide key={thumbIndex}>
                                      <div
                                        className="img-option"
                                        onClick={() => {
                                          handleImageClickSection3Icons(
                                            index,
                                            thumb
                                          );
                                          handleChangeInputS3(
                                            {
                                              target: {
                                                value: thumb,
                                                name: "image",
                                              },
                                            },
                                            true,
                                            activeTab
                                          );
                                        }}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <img
                                          src={thumb}
                                          alt={`Thumb ${thumbIndex + 1}`}
                                          className="img-fluid"
                                          style={{
                                            borderRadius: "8px",
                                            border: "2px solid #ccc",
                                          }}
                                        />
                                      </div>
                                    </SwiperSlide>
                                  ))}
                                </Swiper>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/*     <div className="mb-3">
                      <label className="form-label">Upload Image</label>
                      <input
                        type="file"
                        accept="image/png, image/jpeg"
                        className="form-control"
                        name="image"
                      />
                    </div> */}
                  </div>
                </div>

                {/* Banner Section */}

                <div className="mb-3">
                  <button
                    type="submit"
                    data-bs-dismiss="modal"
                    className="btn primary-btn"
                    onClick={() => {
                      saveJsonDataToFile();
                    }}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- /Order --> */}

        {/* <!-- Delivery --> */}
        <div className="section-editor">
          <a
            href="javascript:void(0);"
            data-bs-toggle="modal"
            data-bs-target="#delivery-schedule"
            className="section-editor-icon"
          >
            <i className="fas fa-edit"></i>
          </a>
          <div className="delivery-section">
            <div className="container">
              <div className="delivery-info">
                <div className="delivery-shape">
                  <img src={shape3} alt="Shape" />
                </div>
                <div className="row align-items-center">
                  <div className="col-lg-7">
                    <div className="delivery-header aos" data-aos="fade-up">
                      <h2
                        style={{
                          color: `#${jsonData?.theme_6?.home?.section_4?.title_color}`,
                        }}
                      >
                        {jsonData?.theme_6?.home?.section_4?.title}
                      </h2>
                      <p
                        style={{
                          color: `#${jsonData?.theme_6?.home?.section_4?.sub_title_color}`,
                        }}
                      >
                        {jsonData?.theme_6?.home?.section_4?.sub_heading_top}
                      </p>
                    </div>
                    <div className="row">
                      {jsonData?.theme_6?.home?.section_4?.cards?.map(
                        (val: any, index: any) => {
                          return (
                            <div
                              className="col-md-4 d-flex aos"
                              data-aos="fade-up"
                            >
                              <div
                                className="delivery-grid w-100"
                                key={index}
                                // style={{
                                //   backgroundColor: `#${val?.bg_color}`,
                                // }}
                              >
                                <div className="delivery-icon">
                                  <img src={val?.image} alt="Icon" />
                                </div>
                                <div className="delivery-text">
                                  <h4
                                    style={{
                                      color: `#${val?.title_color}`,
                                    }}
                                  >
                                    {val?.title}
                                  </h4>
                                  <p
                                    style={{
                                      color: `#${val?.sub_title_color}`,
                                    }}
                                  >
                                    {val?.sub_heading_top}
                                  </p>
                                </div>
                              </div>
                            </div>
                          );
                        }
                      )}
                    </div>
                  </div>
                  <div className="col-lg-5 aos" data-aos="fade-up">
                    <div className="delivery-img">
                      <img
                        src={jsonData?.theme_6?.home?.section_4?.banner}
                        className="img-fluid"
                        alt="Delivery"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="delivery-schedule"
          data-bs-keyboard="false"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Delivery Schedule Theme Edit</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <div className="edit-section">
                  <div className="mb-3">
                    <label className="form-label">
                      Title <small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={editedData?.theme_6?.home?.section_4?.title}
                      onChange={handleChangeInputS4}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      Sub Title <small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="sub_heading_top"
                      value={
                        editedData?.theme_6?.home?.section_4?.sub_heading_top
                      }
                      onChange={handleChangeInputS4}
                    />
                  </div>
                  <div className="row">
                    <div className="col-md">
                      <div className="mb-3">
                        <label className="form-label">Title Color</label>
                        <div className="input-group color-change">
                          <input
                            type="text"
                            className="form-control"
                            name="title_color"
                            // defaultValue="259fed"
                            value={
                              editedData?.theme_6?.home?.section_4?.title_color
                            }
                            onChange={(e) => {
                              handleChangeInputS4(e);
                            }}
                          />
                          <div
                            className="p-colorpicker p-component p-colorpicker-overlay"
                            data-pc-name="colorpicker"
                          >
                            <ColorPicker
                              name="title_color"
                              onChange={(e) => {
                                handleChangeInputS4(e);
                              }}
                              format="hex"
                              value={
                                editedData?.theme_6?.home?.section_4
                                  ?.title_color
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md">
                      <div className="mb-3">
                        <label className="form-label">Sub Title Color</label>
                        <div className="input-group color-change">
                          <input
                            type="text"
                            className="form-control"
                            name="sub_title_color"
                            // defaultValue="259fed"
                            value={
                              editedData?.theme_6?.home?.section_4
                                ?.sub_title_color
                            }
                            onChange={(e) => {
                              handleChangeInputS4(e);
                            }}
                          />
                          <div
                            className="p-colorpicker p-component p-colorpicker-overlay"
                            data-pc-name="colorpicker"
                          >
                            <ColorPicker
                              name="sub_title_color"
                              onChange={(e) => {
                                handleChangeInputS4(e);
                              }}
                              format="hex"
                              value={
                                editedData?.theme_6?.home?.section_4
                                  ?.sub_title_color
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <div className="row">
                      <div className="col-md-12">
                        <label className="form-label">Image</label>
                        <div className="img-bg active">
                          <img
                            src={editedData?.theme_6?.home?.section_4?.banner}
                            alt="Hero Image"
                            className="img-fluid"
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Upload Image</label>
                          <input
                            type="file"
                            accept="image/*, video/*"
                            className="form-control"
                            name="banner_two"
                            onChange={updateImageSection4}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="edit-section">
                  <label className="form-label">Icons</label>
                  <ul className="nav nav-tabs">
                    <Swiper
                      spaceBetween={15}
                      navigation={true}
                      modules={[Navigation]}
                      slidesPerView={3}
                      breakpoints={{
                        640: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                      }}
                      className="homejson-slider"
                    >
                      {deliveryScheduleIcons.map((item, index) => (
                        <SwiperSlide key={index}>
                          <li className="nav-item nav-option">
                            <a
                              className={`nav-link ${
                                activeTab === index ? "active" : ""
                              }`}
                              onClick={() => {
                                console.log(index, "click ind");

                                setActiveTab(index);
                              }}
                            >
                              {item.title}
                            </a>
                          </li>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </ul>

                  <div className="tab-content">
                    {deliveryScheduleIcons.map((item, index) => (
                      <div
                        key={index}
                        className={`tab-pane fade ${
                          activeTab === index ? "show active" : ""
                        }`}
                      >
                        <div className="row">
                          <div className="col-md-12">
                            <div className="img-bg active text-center mb-3">
                              <img
                                src={item.bg}
                                alt="Hero Banner"
                                className="img-fluid"
                                style={{
                                  maxHeight: "300px",
                                  objectFit: "cover",
                                }}
                              />
                            </div>

                            <Swiper
                              spaceBetween={15}
                              navigation={true}
                              modules={[Navigation]}
                              breakpoints={{
                                640: { slidesPerView: 2 },
                                768: { slidesPerView: 3 },
                                1024: { slidesPerView: 4 },
                              }}
                              className="homejson-slider"
                            >
                              {item.thumbnails.map((thumb, thumbIndex) => (
                                <SwiperSlide key={thumbIndex}>
                                  <div
                                    className="img-option"
                                    onClick={() => {
                                      handleImageClickDeliverySIcons(
                                        index,
                                        thumb
                                      );
                                      handleChangeInputS4(
                                        {
                                          target: {
                                            value: thumb,
                                            name: "image",
                                          },
                                        },
                                        true,
                                        activeTab
                                      );
                                    }}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <img
                                      src={thumb}
                                      alt={`Thumb ${thumbIndex + 1}`}
                                      className="img-fluid"
                                      style={{
                                        borderRadius: "8px",
                                        border: "2px solid #ccc",
                                      }}
                                    />
                                  </div>
                                </SwiperSlide>
                              ))}
                            </Swiper>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="row">
                    <div className="col-md">
                      {/* <div className="mb-3">
                        <label className="form-label">
                          Card background Color
                        </label>
                        <div className="input-group color-change">
                          <input
                            type="text"
                            className="form-control"
                            name="bg_color"
                            // defaultValue="259fed"
                            value={
                              editedData?.theme_6?.home?.section_4?.bg_color
                            }
                            disabled={true}
                          />
                          <div
                            className="p-colorpicker p-component p-colorpicker-overlay"
                            data-pc-name="colorpicker"
                          >
                            <ColorPicker
                              name="bg_color"
                              onChange={(e) => {
                                handleChangeInputS4(e, true, activeIndex);
                              }}
                              format="hex"
                              value={
                                editedData?.theme_6?.home?.section_4?.bg_color
                              }
                            />
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      Title <small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      // defaultValue="Delivery Days"
                      value={
                        editedData?.theme_6?.home?.section_4?.cards?.[activeTab]
                          ?.title
                      }
                      onChange={(e) => handleChangeInputS4(e, true, activeTab)}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      Sub Title <small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="sub_heading_top"
                      // defaultValue="Every Tuesday & Friday"
                      value={
                        editedData?.theme_6?.home?.section_4?.cards?.[activeTab]
                          ?.sub_heading_top
                      }
                      onChange={(e) => handleChangeInputS4(e, true, activeTab)}
                    />
                  </div>
                  <div className="row">
                    <div className="col-md">
                      <div className="mb-3">
                        <label className="form-label">Title Color</label>
                        <div className="input-group color-change">
                          <input
                            type="text"
                            className="form-control"
                            name="title_color"
                            // defaultValue="259fed"
                            value={
                              editedData?.theme_6?.home?.section_4?.cards?.[
                                activeTab
                              ]?.title_color
                            }
                            onChange={(e) =>
                              handleChangeInputS4(e, true, activeTab)
                            }
                          />
                          <div
                            className="p-colorpicker p-component p-colorpicker-overlay"
                            data-pc-name="colorpicker"
                          >
                            <ColorPicker
                              name="title_color"
                              onChange={(e) => {
                                handleChangeInputS4(e, true, activeTab);
                              }}
                              format="hex"
                              value={
                                editedData?.theme_6?.home?.section_4?.cards?.[
                                  activeTab
                                ]?.title_color
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md">
                      <div className="mb-3">
                        <label className="form-label">Sub Title Color</label>
                        <div className="input-group color-change">
                          <input
                            type="text"
                            className="form-control"
                            name="sub_title_color"
                            // defaultValue="259fed"
                            value={
                              editedData?.theme_6?.home?.section_4?.cards?.[
                                activeTab
                              ]?.sub_title_color
                            }
                            onChange={(e) =>
                              handleChangeInputS4(e, true, activeTab)
                            }
                          />
                          <div
                            className="p-colorpicker p-component p-colorpicker-overlay"
                            data-pc-name="colorpicker"
                          >
                            <ColorPicker
                              name="sub_title_color"
                              onChange={(e) => {
                                handleChangeInputS4(e, true, activeTab);
                              }}
                              format="hex"
                              value={
                                editedData?.theme_6?.home?.section_4?.cards?.[
                                  activeTab
                                ]?.sub_title_color
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Upload Image/Video */}

                <div className="mb-3">
                  <button
                    type="submit"
                    data-bs-dismiss="modal"
                    className="btn primary-btn"
                    onClick={() => {
                      saveJsonDataToFile();
                    }}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- /Delivery --> */}

        {/* <!-- Place --> */}
        <div className="section-editor">
          <a
            href="javascript:void(0);"
            data-bs-toggle="modal"
            data-bs-target="#how-place"
            className="section-editor-icon"
          >
            <i className="fas fa-edit"></i>
          </a>
          <div className="place-section">
            <div className="container">
              <div className="row">
                <div className="col-md-12 aos" data-aos="fade-up">
                  <div className="section-header">
                    <h2
                      style={{
                        color: `#${jsonData?.theme_6?.home?.section_5?.title_color}`,
                      }}
                    >
                      {jsonData?.theme_6?.home?.section_5?.title}
                      <img src={headingIcon} />
                    </h2>
                    <p
                      style={{
                        color: `#${jsonData?.theme_6?.home?.section_5?.sub_title_color}`,
                      }}
                    >
                      {/* See a quick step-by-step video on booking your laundry
                      service through our platform */}
                      {jsonData?.theme_6?.home?.section_5?.sub_heading_top}
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 aos" data-aos="fade-up">
                  <div className="place-img">
                    {!isPlaying ? (
                      <>
                        <img
                          src={jsonData?.theme_6?.home?.section_5?.banner}
                          className="img-fluid"
                          alt="Place"
                        />
                        <a
                          onClick={handlePlayClick}
                          // className="play-button"
                        >
                          <img src={playIcon} alt="Play Icon" />
                        </a>
                      </>
                    ) : (
                      <div className="video-wrapper">
                        <video
                          controls
                          autoPlay
                          className="img-fluid"
                          style={{ width: "100%", height: "auto" }}
                        >
                          <source src={wbdVedio} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                        <a
                          onClick={handleCloseClick}
                          className="wbd-close-button"
                        >
                          <i className="fa fa-times"></i>
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="how-place"
          data-bs-keyboard="false"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">How to Place Order Theme Edit</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">
                    Title <small>(max 250 char)</small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="title"
                    defaultValue="Watch How to Place an Order"
                    value={editedData?.theme_6?.home?.section_5?.title}
                    onChange={handleChangeInputS5}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Sub Title <small>(max 250 char)</small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="sub_heading_top"
                    defaultValue="See a quick step-by-step video on booking your laundry service through our platform"
                    value={
                      editedData?.theme_6?.home?.section_5?.sub_heading_top
                    }
                    onChange={handleChangeInputS5}
                  />
                </div>

                <div className="row">
                  <div className="col-md">
                    <div className="mb-3">
                      <label className="form-label">Title Color</label>
                      <div className="input-group color-change">
                        <input
                          type="text"
                          className="form-control"
                          name="title_color"
                          // defaultValue="259fed"
                          value={
                            editedData?.theme_6?.home?.section_5?.title_color
                          }
                          onChange={(e) => {
                            handleChangeInputS5(e);
                          }}
                        />
                        <div
                          className="p-colorpicker p-component p-colorpicker-overlay"
                          data-pc-name="colorpicker"
                        >
                          <ColorPicker
                            name="title_color"
                            onChange={(e) => {
                              handleChangeInputS5(e);
                            }}
                            format="hex"
                            value={
                              editedData?.theme_6?.home?.section_5?.title_color
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md">
                    <div className="mb-3">
                      <label className="form-label">Sub Title Color</label>
                      <div className="input-group color-change">
                        <input
                          type="text"
                          className="form-control"
                          name="sub_title_color"
                          // defaultValue="259fed"
                          value={
                            editedData?.theme_6?.home?.section_5
                              ?.sub_title_color
                          }
                          onChange={(e) => {
                            handleChangeInputS5(e);
                          }}
                        />
                        <div
                          className="p-colorpicker p-component p-colorpicker-overlay"
                          data-pc-name="colorpicker"
                        >
                          <ColorPicker
                            name="sub_title_color"
                            onChange={(e) => {
                              handleChangeInputS5(e);
                            }}
                            format="hex"
                            value={
                              editedData?.theme_6?.home?.section_5
                                ?.sub_title_color
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Banner Section */}
                <div className="mb-3">
                  <div className="row">
                    <div className="col-md-12">
                      <label className="form-label">Banner</label>
                      <div className="img-bg active">
                        <img
                          src={editedData?.theme_6?.home?.section_5?.banner}
                          alt="Hero Image"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Upload Image/Video */}
                <div className="mb-3">
                  <label className="form-label">Upload Image</label>
                  <input
                    type="file"
                    accept="image/*, video/*"
                    className="form-control"
                    name="banner_two"
                    onChange={updateImageSection5}
                  />
                </div>

                <div className="mb-3">
                  <button
                    type="submit"
                    data-bs-dismiss="modal"
                    className="btn primary-btn"
                    onClick={() => {
                      saveJsonDataToFile();
                    }}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- /Place --> */}

        {/* <!-- Ready --> */}
        <div className="section-editor">
          <a
            href="javascript:void(0);"
            data-bs-toggle="modal"
            data-bs-target="#ready-schedule"
            className="section-editor-icon"
          >
            <i className="fas fa-edit"></i>
          </a>
          <div className="ready-section">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-sm-9 aos" data-aos="fade-up">
                  <div className="ready-header">
                    <h2
                      style={{
                        color: `#${jsonData?.theme_6?.home?.section_6?.title_color}`,
                      }}
                    >
                      {jsonData?.theme_6?.home?.section_6?.title}
                    </h2>
                    <p
                      style={{
                        color: `#${jsonData?.theme_6?.home?.section_6?.sub_title_color}`,
                      }}
                    >
                      {jsonData?.theme_6?.home?.section_6?.sub_heading_top}
                    </p>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="ready-btn aos" data-aos="fade-up">
                    <a
                      href="javascript:void(0);"
                      className="btn btn-primary"
                      style={{
                        backgroundColor: `#${jsonData?.theme_6?.home?.section_6?.btn_bg_color}`,
                        color: `#${jsonData?.theme_6?.home?.section_6?.btn_color}`,
                      }}
                    >
                      {jsonData?.theme_6?.home?.section_6?.button_text}{" "}
                      <i className="ti ti-arrow-narrow-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="ready-schedule"
          data-bs-keyboard="false"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Ready to Schedule Theme Edit</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">
                    Title <small>(max 250 char)</small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="title"
                    // defaultValue="Ready to Schedule Your Laundry?"
                    value={editedData?.theme_6?.home?.section_6?.title}
                    onChange={handleChangeInputS6}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Sub Title <small>(max 250 char)</small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="sub_heading_top"
                    defaultValue="Confirm in under a minute. Fixed booking fee applies"
                    value={
                      editedData?.theme_6?.home?.section_6?.sub_heading_top
                    }
                    onChange={handleChangeInputS6}
                  />
                </div>
                <div className="row">
                  <div className="col-md">
                    <div className="mb-3">
                      <label className="form-label">Title Color</label>
                      <div className="input-group color-change">
                        <input
                          type="text"
                          className="form-control"
                          name="title_color"
                          // defaultValue="259fed"
                          value={
                            editedData?.theme_6?.home?.section_6?.title_color
                          }
                          onChange={(e) => {
                            handleChangeInputS6(e);
                          }}
                        />
                        <div
                          className="p-colorpicker p-component p-colorpicker-overlay"
                          data-pc-name="colorpicker"
                        >
                          <ColorPicker
                            name="title_color"
                            onChange={(e) => {
                              handleChangeInputS6(e);
                            }}
                            format="hex"
                            value={
                              editedData?.theme_6?.home?.section_6?.title_color
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md">
                    <div className="mb-3">
                      <label className="form-label">Sub Title Color</label>
                      <div className="input-group color-change">
                        <input
                          type="text"
                          className="form-control"
                          name="sub_title_color"
                          // defaultValue="259fed"
                          value={
                            editedData?.theme_6?.home?.section_6
                              ?.sub_title_color
                          }
                          onChange={(e) => {
                            handleChangeInputS6(e);
                          }}
                        />
                        <div
                          className="p-colorpicker p-component p-colorpicker-overlay"
                          data-pc-name="colorpicker"
                        >
                          <ColorPicker
                            name="sub_title_color"
                            onChange={(e) => {
                              handleChangeInputS6(e);
                            }}
                            format="hex"
                            value={
                              editedData?.theme_6?.home?.section_6
                                ?.sub_title_color
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <div className="row">
                    <div className="col">
                      <div className="mb-3">
                        <label className="form-label">Button</label>
                        <input
                          type="text"
                          className="form-control"
                          name="button_text"
                          // defaultValue="Book Now"
                          value={
                            editedData?.theme_6?.home?.section_6?.button_text
                          }
                          onChange={handleChangeInputS6}
                        />
                      </div>
                    </div>
                    <div className="col">
                      <div className="mb-3">
                        <label className="form-label">Background</label>
                        <div className="input-group color-change">
                          <input
                            type="text"
                            className="form-control"
                            name="btn_bg_color"
                            // defaultValue="259fed"
                            value={
                              editedData?.theme_6?.home?.section_6?.btn_bg_color
                            }
                            onChange={(e) => {
                              handleChangeInputS6(e);
                            }}
                          />
                          <div
                            className="p-colorpicker p-component p-colorpicker-overlay"
                            data-pc-name="colorpicker"
                          >
                            <ColorPicker
                              name="btn_bg_color"
                              onChange={(e) => {
                                handleChangeInputS6(e);
                              }}
                              format="hex"
                              value={
                                editedData?.theme_6?.home?.section_6
                                  ?.btn_bg_color
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="mb-3">
                        <label className="form-label">Color</label>
                        <div className="input-group color-change">
                          <input
                            type="text"
                            className="form-control"
                            name="btn_color"
                            // defaultValue="259fed"
                            value={
                              editedData?.theme_6?.home?.section_6?.btn_color
                            }
                            onChange={(e) => {
                              handleChangeInputS6(e);
                            }}
                          />
                          <div
                            className="p-colorpicker p-component p-colorpicker-overlay"
                            data-pc-name="colorpicker"
                          >
                            <ColorPicker
                              name="btn_color"
                              onChange={(e) => {
                                handleChangeInputS6(e);
                              }}
                              format="hex"
                              value={
                                editedData?.theme_6?.home?.section_6?.btn_color
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Banner Section */}

                {/* Upload Image/Video */}
                <div className="mb-3">
                  <button
                    type="submit"
                    data-bs-dismiss="modal"
                    className="btn primary-btn"
                    onClick={() => {
                      saveJsonDataToFile();
                    }}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- /Ready --> */}

        {/* <!-- Footer --> */}
        {/* <footer className="footer">
          <div className="container">
            <div className="footer-top aos" data-aos="fade-up">
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget">
                    <div className="footer-about">
                      <p>Ready to take laundry off your to-do list? services is a local laundry pickup and delivery service that you can order directly from your smart phone.</p>
                    </div>
                    <div className="footer-social">
                      <a href="javascript:void(0);"><i className="fab fa-facebook hi-icon"></i></a>
                      <a href="javascript:void(0);"><i className="fab fa-instagram hi-icon"></i></a>
                      <a href="javascript:void(0);"><i className="fab fa-youtube hi-icon"></i></a>
                      <a href="javascript:void(0);"><i className="fa-brands fa-twitter hi-icon"></i></a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-6">
                  <div className="footer-widget">
                    <h2>Quick Links</h2>
                    <ul>
                      <li>
                        <a href="javascript:void(0);">About Us</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">Our Services</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">Terms & Conditions</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">Privacy Policy</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">Cookie Policy</a>
                      </li>	
                    </ul>
                  </div>
                </div>
                <div className="col-lg-2 col-md-6">
                  <div className="footer-widget">
                    <h2>Explore</h2>
                    <ul>
                      <li>
                        <a href="javascript:void(0);">How it works</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">Services</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">Locations</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget">
                    <h2>Call Today to Discuss Your Service Needs</h2>
                    <ul>
                      <li>0987654321</li>
                      <li>locallaunderette103@gmail.com</li>
                      <li>admin@laundryup.co.uk</li>
                      <li>103 Eastbury Road, Watford, WD19 4JP</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="copy-rights">
                    <p>
                      © 2025. All rights reserved. | Powered by
                      <a href="javascript:void(0);">www.bestatservices.com</a>
                    <p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer> */}
        {/* <!-- /Footer --> */}

        {/* <!-- Cursor --> */}
        <div className="mouse-cursor cursor-outer"></div>
        <div className="mouse-cursor cursor-inner"></div>
        {/* <!-- /Cursor --> */}
      </div>
      {/* <!-- /Main Wrapper --> */}

      {/* <!-- ScrollToTop --> */}
      {/* <div className="progress-wrap active-progress">
        <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
        <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" style={{transition: 'stroke-dashoffset 10ms linear 0s; stroke-dasharray: 307.919px, 307.919px; stroke-dashoffset: 228.265px;'}}></path>
        </svg>
      </div> */}
      {/* <!-- /ScrollToTop --> */}
    </>
  );
}

export default WBDEdit;
